
import { createContext, useReducer } from "react";
import InfopersonReducer from "./InfopersonReducer";

const INITIAL_STATE = {
    infoperson: {},
    message: "",
    isFetchingGet: false,
    errorGet: false,
    isFetchingUpdate: false,
    errorUpdate: false,
    isFetchingDelete: false,
    errorDelete: false,
};


export const InfopersonContext = createContext(INITIAL_STATE);

export const InfopersonContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(InfopersonReducer, INITIAL_STATE);
    
    return (
      <InfopersonContext.Provider
        value={{
          infoperson: state.infoperson,
          message: state.message,
          isFetchingGet: state.isFetchingGet,
          errorGet: state.errorGet,
          isFetchingUpdate: state.isFetchingUpdate,
          errorUpdate: state.errorUpdate,
          isFetchingDelete: state.isFetchingDelete,
          errorDelete: state.errorDelete,
          dispatch,
        }}
      >
        {children}
      </InfopersonContext.Provider>
    );
  };